import {storyBase} from "@/lib/api/sanity/queries/storyBase";

const previewStoryBySlug = `
* [_type == 'story' && slug.current == $slug]
${storyBase}
| order(_updatedAt desc)
[0]
`
export default previewStoryBySlug
